import z from "zod";

export const FormSectionValues = [
  // Create Incident
  "createIncidentMain",

  // Triage Incident
  "triageMain",

  // Section 136
  "personDetails",
  "detentionDetails",
  "informationForHealthcare",

  // Section 136 Rejected
  "s136FormRejected",

  // Mental Capacity Act
  "mcaPersonDetails",
  "mcaIncidentDetails",
  "mcaCapacityAssessment",
  "mcaAccompaniment",

  // Record Places of Safety
  "recordPlaceOfSafetyMain",
  "recordPlaceOfSafetyArrival",
  "recordPlaceOfSafetyLeave",

  // Share Incident
  "shareIncident",

  // Request Police Presence
  "requestPolicePresenceMain",
  "recordPolicePresence",

  // Pre-End Incident
  "preEndIncident",

  // Finish Form
  "finishForm",
] as const;

export type FormSection = (typeof FormSectionValues)[number];

export const FormSectionSchema = z.enum({
  // Create Incident
  createIncidentMain: "createIncidentMain",

  // Triage Incident
  triageMain: "triageMain",

  // Section 136
  personDetails: "personDetails",
  detentionDetails: "detentionDetails",
  informationForHealthcare: "informationForHealthcare",

  // Section 136 Rejected
  s136FormRejected: "s136FormRejected",

  // Mental Capacity Act
  mcaPersonDetails: "mcaPersonDetails",
  mcaIncidentDetails: "mcaIncidentDetails",
  mcaCapacityAssessment: "mcaCapacityAssessment",
  mcaAccompaniment: "mcaAccompaniment",

  // Record Places of Safety
  recordPlaceOfSafetyMain: "recordPlaceOfSafetyMain",
  recordPlaceOfSafetyArrival: "recordPlaceOfSafetyArrival",
  recordPlaceOfSafetyLeave: "recordPlaceOfSafetyLeave",

  // Share Incident
  shareIncident: "shareIncident",

  // Request Police Presence
  requestPolicePresenceMain: "requestPolicePresenceMain",
  recordPolicePresence: "recordPolicePresence",

  // Pre-End Incident
  preEndIncident: "preEndIncident",

  // Finish Form
  finishForm: "finishForm",
} satisfies Record<string, FormSection>);
